module.exports = __webpack_public_path__ + "media/footsteps-short.e3e793cd.mp3";